<template>
  <section>
    <div class="contentBlock">
      <p class="title">註冊</p>
      <form @submit="signupRequest">
        <div class="formBlock">
          <label class="formLabel"
            >設定帳號
            <input
              type="text"
              class="inputLayout"
              placeholder="請輸入電子信箱"
              aria-label="會員帳號，請輸入電子信箱"
              v-model="user.email"
            />
          </label>
          <label class="formLabel">
            設定密碼
            <input
              type="password"
              class="inputLayout"
              aria-label="請輸入6個以上英數字"
              placeholder="會員密碼，請輸入6個以上英數字"
              v-model="user.password"
            />
          </label>
        </div>
        <button
          @click="signupRequest"
          class="loginBtn signupLayout"
          title="註冊"
          >註冊</button
        >
      </form>
      <button
        @click="FBlogin"
        class="loginBtn fbLayout"
        title="[另開新分頁]前往FB註冊"
      >
        <img :src="facebook" alt="臉書" class="facebookLogo" />
        Facebook登入
      </button>
      <div class="additionAction">
        <router-link :to="{ name: 'login' }" title="[前往]登入頁面"
          >已經有帳號了？登入</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
import facebook from '@/assets/images/member-system/FB_icon.svg';

export default {
  name: 'MemberRegister',
  metaInfo() {
    return {
      title: '會員註冊',
    };
  },
  data() {
    return {
      user: {
        email: '',
        password: '',
        is_admin: false,
      },
      facebook,
    };
  },
  created() {
    window.fbAsyncInit = function() {
      FB.init({
        appId: '510483459734954',
        xfbml: true,
        version: 'v5.0',
      });
      FB.AppEvents.logPageView();
    };

    (function(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  },
  mounted() {},
  methods: {
    isInputRequired() {
      if (this.user.email === '' || this.user.password === '') {
        alert('請填入信箱和密碼');
        return false;
      }

      if (!/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9]{6,}$/.test(this.user.password)) {
        alert('請輸入含英數字，六位以上的密碼');
        return false;
      }
      return true;
    },
    signupRequest(e) {
      e.preventDefault();

      if (this.isInputRequired()) {
        this.$store
          .dispatch('signupRequest', this.user)
          .then(() => {
            alert('註冊成功，跳轉頁面中...');
            this.$router.push('/');
          })
          .catch((error) => {
            // 後端已將錯誤訊息中文化，不再比對英文字串，直接顯示後端回的訊息
            if (error && error.email && error.email.length) {
              alert(error.email[0]);
            }
            throw error;
          });
      }
    },
    FBlogin() {
      let self = this;
      FB.login(
        function(response) {
          // handle the response
          // console.log(response)
          if (response.authResponse) {
            const userFB = {
              user_id: response.authResponse.userID,
              access_token: response.authResponse.accessToken,
            };
            self.$store
              .dispatch('FBlogin', userFB)
              .then(() => {
                window.alert('已登入，重新跳轉頁面');
                self.$router.push(self.$route.query.redirect || '/');
              })
              .catch((e) => {
                alert('登入失敗');
                throw e;
              });
          }
        },
        { scope: 'public_profile' }
      );
    },
    statusChangeCallback(response) {
      // Called with the results from FB.getLoginStatus().
      // console.log('statusChangeCallback');
      // console.log(response); // The current login status of the person.
      if (response.status === 'connected') {
        // Logged into your webpage and Facebook.
        this.testAPI();
      } else {
        // Not logged into your webpage or we are unable to tell.
        // document.getElementById('status').innerHTML = 'Please log ' +
        //   'into this webpage.';
        // console.log('Please log into this webpage.');
      }
    },
    checkLoginState() {
      // console.log('second'); // Called when a person is finished with the Login Button.
      FB.getLoginStatus(function(response) {
        // See the onlogin handler
        this.statusChangeCallback(response);
      });
    },
    testAPI() {
      // Testing Graph API after login.  See statusChangeCallback() for when this call is made.
      // console.log('Welcome!  Fetching your information.... ');
      FB.api('/me', function(response) {
        // console.log('Successful login for: ' + response.name);
        // document.getElementById('status').innerHTML =
        //   'Thanks for logging in, ' + response.name + '!';
        // console.log('Successful login');
        // console.log(response);
      });
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
button {
  border: none;
}

.contentBlock {
  margin: auto;
  width: 280px;
  @include for-tablet {
    width: 522px;
  }

  @include for-tablet-horizontal {
    padding-top: 40px;
  }
}

.title {
  margin: 20px 0 40px;
  font-family: $text-font-family;
  font-size: 24px;
  color: $color-light-text;
  text-align: center;
  letter-spacing: 1.14px;

  @include for-tablet {
    font-size: 32px;
    margin-top: 60px;
  }
}

.formBlock {
  .formLabel {
    color: $color-light-text;
    font-size: 21px;
    letter-spacing: 1.71px;
    font-family: $text-font-family;
  }

  .inputLayout {
    border: 1px solid $color-light-border;
    width: 100%;
    height: 50px;
    padding: 10px 30px;
    margin-top: 10px;
    margin-bottom: 30px;
    font-size: 18px;
    color: #979797;
    border-radius: 25px;
    box-sizing: border-box;
    &::placeholder {
      color: #979797;
    }
  }
}

.loginBtn {
  width: 100%;
  padding: 10px;
  height: 50px;
  box-sizing: border-box;
  border-radius: 32px;
  cursor: pointer;
  font-size: 21px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  letter-spacing: 1.5px;
  img {
    width: 21px;
    margin-right: 10px;
  }
}

.fbLayout {
  background-color: #4267b2;
}

.signupLayout {
  background-color: $color-light-btn-bg;
}

.additionAction {
  text-align: center;
  margin: 10px 0 40px;

  @include for-tablet {
    margin-bottom: 60px;
  }

  a {
    color: $color-light-text;
    text-decoration: underline;
  }
}
</style>
